export default __webpack_public_path__ + "static/media/arrow_point_down.c70be133.svg";